import React from "react";
import { Flex } from "../../pages/styled";
import { StyledButton } from "../contact/styled";
import {
  BackButtonTop,
  OptionalText,
  QuestionText,
  QuestionWrapper,
} from "./styled";
import { ReactComponent as GoBack } from "../../assets/img/svg2/Vector.svg";

export default function Question({
  icon,
  text,
  options,
  goToStep,
  noButton,
  optionalText,
}) {
  return (
    <>
      {!noButton && (
        <BackButtonTop onClick={goToStep} top>
          <GoBack style={{ marginRight: "1rem" }} />
          Regresar
        </BackButtonTop>
      )}
      <QuestionWrapper>
        {icon}
        <QuestionText>{text}</QuestionText>
        <Flex style={{ width: "100%" }}>
          {options.map((e) => (
            <StyledButton onClick={e.action}>{e.label}</StyledButton>
          ))}
        </Flex>
        {optionalText && <OptionalText>{optionalText}</OptionalText>}
      </QuestionWrapper>
      {!noButton && (
        <BackButtonTop onClick={goToStep}>
          <GoBack style={{ marginRight: "1rem" }} />
          Regresar
        </BackButtonTop>
      )}
    </>
  );
}
